export const DEFAULT = 'default'
export const OTHER = 'other'
export const REVIEWED = 'reviewed'
export const PUBLISHED = 'published'
export const NOT_AVAILABLE = '__NOT_AVAILABLE'
export const UNDEFINED = '__UNDEFINED'